import { z } from 'zod';

const hex24 = z.string().regex(/^[a-fA-F0-9]{24}$/);

/** Optional 24-char hex id; empty string / null / undefined become undefined */
export const optionalMongoIdString = z.preprocess(
    (val) => (val === '' || val === null || val === undefined ? undefined : val),
    hex24.optional()
);

/** Update: same as optionalMongoIdString but allows explicit `null` to clear the ref */
export const optionalMongoIdOrNull = z.preprocess(
    (val) => {
        if (val === '' || val === null) return null;
        if (val === undefined) return undefined;
        return val;
    },
    z.union([hex24, z.null()]).optional()
);
